import { useSyncExternalStore } from "react";

/** Subscribes to a CSS media query (used to switch the IDE to a single-view layout on narrow screens). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(query);
      m.addEventListener("change", cb);
      return () => m.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
  );
}
